export const WHATSAPP_INTEGRATION_LOCK = {
  WHITELABEL: "whitelabel",
  OMNICHANNEL: "omnichannel",
};
